import _styled from "@emotion/styled/base";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { colors } from "./auth-service-tools26.js";

const LoadingDotsContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e19jzi5q0"
} : {
  target: "e19jzi5q0",
  label: "LoadingDotsContainer"
})("@keyframes load{0%{opacity:0;}50%{opacity:1;}100%{opacity:0;}}.loading-dots{animation:load 1s infinite;animation-fill-mode:both;}.loading-dots:nth-of-type(2){animation-delay:0.2s;}.loading-dots:nth-of-type(3){animation-delay:0.4s;}", (_ref) => {
  let {
    centered
  } = _ref;
  return centered && `
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const LoadingDots = (_ref2) => {
  let {
    fill = colors.GRAYSCALE.X50,
    height = 40,
    centered = false,
    testId = null
  } = _ref2;
  const svgHeight = `${height}px`;
  const svgWidth = `${height * 3}px`;
  return /* @__PURE__ */jsx(LoadingDotsContainer, {
    "data-testid": testId || "loading-dots",
    centered,
    children: /* @__PURE__ */jsxs("svg", {
      height: svgHeight,
      width: svgWidth,
      viewBox: "0 0 10 2",
      xmlns: "http://www.w3.org/2000/svg",
      className: "loading-dots-svg",
      children: [/* @__PURE__ */jsx("circle", {
        className: "loading-dots",
        fill,
        cx: "1",
        cy: "1",
        r: "1"
      }), /* @__PURE__ */jsx("circle", {
        className: "loading-dots",
        fill,
        cx: "5",
        cy: "1",
        r: "1"
      }), /* @__PURE__ */jsx("circle", {
        className: "loading-dots",
        fill,
        cx: "9",
        cy: "1",
        r: "1"
      })]
    })
  });
};

export { LoadingDots };